import React from "react";
import "./BooksCover.css";

export const BooksCover = ({ coverImage }) => {
  return (
    <div className="books__left">
      <img src={coverImage} alt="" />
    </div>
  );
};
